export default __webpack_public_path__ + "static/media/EmptyMedicalReport.6d8d979b.svg";